<div (click)="close()" class="image-modal">

      <i (click)="close()" class="close-btn fal text-32 text-white fa-times"></i >
  
    <img [src]="data.imageUrl" alt="Full Image" (click)="$event.stopPropagation()" />
</div>